:host {
  display: block;
}
.footer-gradient {
  background: linear-gradient(180deg, #022962 0%, #022962 0.01%, #012251 100%);
  @media screen and (max-width: 640px) {
    background: linear-gradient(360deg, #032962 33.63%, #053e94 100%);
  }
}
.copyrights_bg {
  background: #02439c;
  @media screen and (max-width: 640px) {
    background: #021d46;
  }
}
